<ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </ng-container>
<div class="card card-custom gutter-b" style="margin-bottom: 20px;">
    <div class="card-header">
      <div class="card-title">
        <h4 class="card-label" style="margin: 15px;font-weight: bold;">
          {{'APPOINTMENTS.ADD.DOCTOR' | translate}}
        </h4>
      </div>
    </div>
    <div class="card-body">
        <section class="doctors-area doctors-area-two pt-100">
            <div class="container">
                <div class="row">
                    <div *ngFor="let Doctor of SpecialtyDoctors;let i = index"
                    class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                        <div class="doctor-item" (mouseenter)="OnMouseEnter(i)" (mouseleave)="OnMouseLeave(i)">
                            <div class="doctor-top" *ngIf="DoctorImg[i]" >
                                <img *ngIf="Doctor.picPath != null;else NoDocPic" [src]="Doctor.picPath | SafeImgUrlPipe" alt="Doctor">
                                <ng-template #NoDocPic><img src="assets/img/doctor/Avatar.png" alt="Doctor"></ng-template>
                                <a [routerLink]="'/portal/appointments/addappointment/' + Doctor.employee?.departmentId +'/' + Doctor.employee?.empId">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 

                            </div>
                            <div class="doctor-top" *ngIf="DoctorAbout[i]" >
                                <!-- <p> {{ language == 'en'?  Doctor.aboutEn : Doctor.aboutAr}}</p> -->
                                <textarea style="border: none;height: 410px;display: flex;justify-content: center;align-items: center;" readonly class="form-control"  [value]=" language == 'en'?  Doctor.aboutEn : Doctor.aboutAr"></textarea>

                                <a [routerLink]="'/portal/appointments/addappointment/' + Doctor.employee?.departmentId +'/' + Doctor.employee?.empId">{{ language == 'en'? 'Get Appointment': 'احجز موعدك' }}</a> 

                            </div>
                            <div class="doctor-bottom">
                                <h3 style="cursor:pointer;"><a [routerLink]="'/portal/appointments/addappointment/' + Doctor.employee?.departmentId +'/' + Doctor.employee?.empId" >
                                    {{ language == 'en'? 'Dr. '+ Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.lastName
                                    : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName }}</a></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
  </div>
